// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"115":"students","130":"teaching","133":"layout","242":"schools","255":"test","473":"analysis","962":"home","966":"login"}[chunkId] + "." + {"115":"64df1b46","130":"3bd7468f","133":"9e81a746","242":"b9575ec0","255":"8da7d697","473":"3dd1b018","962":"9b8de05d","966":"2c0c1193"}[chunkId] + ".css";
};